var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("抱歉，你访问的页面不存在")]),_c('a-button',{attrs:{"type":"primary","size":"large"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(" 返回首页 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }